class CollectionCarousel extends HTMLElement {
  constructor() {
    super();
    var swiper = new Swiper(".js-tabs-carousel", {
      slidesPerView: 1.5,
      spaceBetween: 8,
      breakpoints: {
        769: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4.565,
          spaceBetween: 20,
        }
      }
    });
  }
}

customElements.define('collection-carousel', CollectionCarousel);
